module.exports = __webpack_public_path__ + "img/14ne.507a4274.svg";